import { Action, createReducer, on } from "@ngrx/store";
import { IClubLobbyState, INIT_CLUB_LOBBY_STATE, IStateClubGame } from "./clubLobby.state";
import * as ClubLobbyActions from './clubLobby.actions';

const _clubLobbyReducer = createReducer(

    INIT_CLUB_LOBBY_STATE,

    on(
        ClubLobbyActions.updateGameTable,
        (state, action) => {
            const copyGames = { ...state.games };
            copyGames[action.game.id] = action.game;
            return {
                ...state,
                games: copyGames,
            }
        }
    ),

    on(
        ClubLobbyActions.removeGameTable,
        (state, action) => {
            const copyGames = { ...state.games };
            delete copyGames[action.tableId];
            const filteredGames = copyGames;
            return {
                ...state,
                games: filteredGames,
            }
        }
    ),

    on(
        ClubLobbyActions.updateUnionGameTable,
        (state, action) => {
            const unionState = state.unionGames;
            const oldClubLobbyState = unionState[action.clubId];
            const newClubLobbyState = {...oldClubLobbyState};
            newClubLobbyState[action.tableId] = action.game;
            unionState[action.clubId] = newClubLobbyState;
            return {
                ...state,
                unionGames: unionState,
            }
        }
    ),

    on(
        ClubLobbyActions.removeUnionGameTable,
        (state, action) => {
            const filteredGames = { ...state.unionGames };
            delete filteredGames[action.clubId][action.tableId];
            return {
                ...state,
                unionGames: filteredGames,
            }
        }
    ),

    on(
        ClubLobbyActions.removeUnionClubGames,
        (state, action) => {
            const filteredGames = { ...state.unionGames };
            delete filteredGames[action.clubId];
            return {
                ...state,
                unionGames: filteredGames,
            }
        }
    ),

    on(
        ClubLobbyActions.setSelectedFilter,
        (state, action) => ({
            ...state,
            selectedFilter: action.selectedFilter
        })
    ),

      on(
        ClubLobbyActions.setIsUnionSelected,
        (state, action) => ({
            ...state,
            isUnionSelected: action.isUnionSelected
        })
    ),

    on(
        ClubLobbyActions.resetGamesState,
        (state) => ({
            ...state,
            games: {},
            unionGames: {},
            isUnionSelected: false,
        })
    ),
);

export function clubLobbyReducer(state: IClubLobbyState, action: Action) {
    return _clubLobbyReducer(state, action);
}
